import React, { Component } from 'react'
import styled from 'styled-components'

class Typewriter extends Component {
  constructor(props) {
    super(props)

    this.typewriter = this.typewriter.bind(this)
    this.reverseTypewriter = this.reverseTypewriter.bind(this)
  }

  componentDidMount() {
    this.typewriter(this.props.array, 0, 0)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  typewriter(array, n, idx) {
    if (idx === array.length) {
      idx = 0
    }
    const element = document.querySelector('.typewriter')
    const word = element.innerText
    if (n < array[idx].length) {
      element.innerHTML = array[idx].substring(0, n + 1)
      n++
      this.timer = setTimeout(() => {
        this.typewriter(array, n, idx)
      }, 75)
    } else {
      this.timer = setTimeout(
        () => this.reverseTypewriter(array, word.length, idx),
        2000
      )
    }
  }

  reverseTypewriter(array, n, idx) {
    const element = document.querySelector('.typewriter')
    const word = element.innerText
    if (word.length > 0) {
      element.innerHTML = array[idx].substring(0, n - 1)
      n--
      this.timer = setTimeout(() => {
        this.reverseTypewriter(array, n, idx)
      }, 75)
    } else {
      idx++
      this.timer = setTimeout(() => this.typewriter(array, 0, idx), 1000)
    }
  }

  render() {
    let textSize = this.props.fontSize ? this.props.fontSize : '2rem'
    return (
      <TypewriterContainer
        style={{ fontSize: textSize }}
        className="typewriter"
      />
    )
  }
}

export default Typewriter

const TypewriterContainer = styled.span``



// WEBPACK FOOTER //
// ./src/components/UI/typewriter.jsx